import createRouter from '@updater/app-shell';
import { withHTMLComponent } from '@updater-local/custom-element-v1';
import '../../components/heading';
import { ROUTES as ROOT_ROUTES } from '../../constants';
import { clonePrimitive, getClientState } from '../../store/utils';
import createMountFn from '../../hyperhtml-mount';
import routesConfig from './routes-config';
import styles from './index.css';
import html from './index.html';

export default class LandingPageRoute extends withHTMLComponent(
  styles,
  html
)() {
  constructor(_router, { store: _store, updStore: _updStore }) {
    super();

    Object.assign(this, { _router, _store, _updStore });
  }

  connected() {
    // "Terminal" state for Intrastate users.
    this._updStore.shouldSeeSurvey(false);

    getClientState(this._store).then(state => {
      this.mergeState(clonePrimitive(state));

      this._subRouter = createRouter(
        {
          basePath: this._router.config.basePath + ROOT_ROUTES.landingPage,
          element: this.shadowRoot,
          mountFn: createMountFn(),
          routes: routesConfig,
        },
        {
          store: this._store,
          parentRouter: this._router,
          getState: () => ({ ...this._state }),
          updStore: this._updStore,
        }
      );

      this._subRouter.init();
    });
  }

  disconnected() {
    this._subRouter.destroy();
  }
}

customElements.define('upd-moveiq-landing-page-route', LandingPageRoute);
